import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { ApiservicesService } from 'src/app/services/apiservices.service';
import { environment } from 'src/environments/environment';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'app-perennial-subscription-success',
  templateUrl: './perennial-subscription-success.component.html',
  styleUrls: ['./perennial-subscription-success.component.scss'],
})
export class PerennialSubscriptionSuccessComponent implements OnInit {
  loading = true;
  success = false;
  message = '';
  paymentDetails: any;
  public baseUrl: any = environment.api_url;
  public perennialStripeUserDetails: any = {};
  today: string = new Date().toLocaleDateString();

  constructor(
    private route: ActivatedRoute,
    public router: Router,
    private http: HttpClient,
    private apiservice: ApiservicesService,
    public cookieService: CookieService
  ) {}

  ngOnInit(): void {
    this.perennialStripeUserDetails = this.cookieService.get(
      'perennialStripeUserDetails'
    )
      ? JSON.parse(this.cookieService.get('perennialStripeUserDetails'))
      : {};
    console.log(
      'this.perennialStripeUserDetails---->',
      this.perennialStripeUserDetails
    );

    this.route.queryParams.subscribe((params) => {
      const paymentIntentId = params['payment_intent'];
      const setupIntentId = params['setup_intent'];
      const redirectStatus = params['redirect_status']; // For SetupIntents

      if (paymentIntentId) {
        console.log('Processing PaymentIntent:', paymentIntentId);
        this.handlePaymentIntent(paymentIntentId);
      } else if (setupIntentId) {
        console.log(
          'Processing SetupIntent:',
          setupIntentId,
          'with status:',
          redirectStatus
        );
        this.handleSetupIntent(setupIntentId, redirectStatus);
      } else {
        this.message =
          'No payment_intent or setup_intent found in query parameters.';
        console.warn(this.message);
        this.loading = false;
        this.success = false;
      }
    });
  }

  handlePaymentIntent(paymentIntentId: string): void {
    this.http
      .get<any>(
        `${this.baseUrl}cart_management/perennial-payment-complete?payment_intent_id=${paymentIntentId}`
      )
      .subscribe({
        next: (res) => {
          console.log('Backend response for PaymentIntent:', res);
          // Ensure res has an object_type or add it for consistency
          this.paymentDetails = { ...res, object_type: 'payment_intent' };
          this.loading = false;

          if (res.status === 'succeeded') {
            let body = {
              payment_id: res.id,
              payment_status: 'succeeded',
              amount: res.amount,
              currency: res.currency,
              payment_process_details: res,
              customer_id: this.perennialStripeUserDetails.user_id,
              stripe_customer_id: this.perennialStripeUserDetails.customer_id,
              subscription_id: this.perennialStripeUserDetails.subscription_id,
              email: this.perennialStripeUserDetails.email,
              transaction_type: 'payment',
            };

            this.saveTransactionAndUpdateCookie(
              body,
              res.status === 'succeeded'
            );

            this.success = true;
            this.message = 'Your payment was successful!';
          } else if (res.status === 'processing') {
            this.success = false;
            this.message = 'Payment is processing...';
          } else {
            let body = {
              payment_id: res.id,
              payment_status: 'failed',
              amount: res.amount,
              currency: res.currency,
              payment_process_details: res,
              customer_id: this.perennialStripeUserDetails.user_id,
              stripe_customer_id: this.perennialStripeUserDetails.customer_id,
              subscription_id: this.perennialStripeUserDetails.subscription_id,
              email: this.perennialStripeUserDetails.email,
              transaction_type: 'payment',
            };

            this.saveTransactionAndUpdateCookie(body, false);

            this.success = false;
            this.message = `Payment ${res.status}.`;
          }
        },
        error: (err) => {
          console.error('Error fetching PaymentIntent details:', err);
          this.loading = false;
          this.success = false;
          this.message = 'Failed to retrieve payment details.';
        },
      });
  }

  handleSetupIntent(
    setupIntentId: string,
    redirectStatus: string | null
  ): void {
    this.loading = true;
    this.http
      .get<any>(
        `${this.baseUrl}stripe/default-setup-complete?payment_intent=${setupIntentId}`
      )
      .subscribe({
        next: (res) => {
          // Populate this.paymentDetails for the template
          this.paymentDetails = { ...res, object_type: 'setup_intent' };
          this.loading = false;

          console.log("Backend response for SetupIntent:", res,res.status);
          
          if (res.status === 'succeeded') {
            let body = {
              payment_id: setupIntentId,
              payment_status: 'succeeded',
              amount: 0,
              currency: '',
              payment_process_details: res,
              customer_id: this.perennialStripeUserDetails.user_id,
              stripe_customer_id: this.perennialStripeUserDetails.customer_id,
              subscription_id: this.perennialStripeUserDetails.subscription_id,
              email: this.perennialStripeUserDetails.email,
              transaction_type: 'setup',
            };

            this.saveTransactionAndUpdateCookie(body, true);

            this.success = true;
            this.message = 'Your payment method has been saved successfully!';
          } else if (res.status === 'processing') {
            this.success = false;
            this.message = 'Saving payment method is processing...';
          } else {
            let body = {
              payment_id: setupIntentId,
              payment_status: 'failed',
              amount: 0,
              currency: '',
              payment_process_details: res,
              customer_id: this.perennialStripeUserDetails.user_id,
              stripe_customer_id: this.perennialStripeUserDetails.customer_id,
              subscription_id: this.perennialStripeUserDetails.subscription_id,
              email: this.perennialStripeUserDetails.email,
              transaction_type: 'setup',
            };

            this.saveTransactionAndUpdateCookie(body, false);

            this.success = false;
            this.message = `Saving payment method failed with status: ${res.status}`;
          }
        },
        error: (err) => {
          console.error('Error fetching SetupIntent details:', err);
          this.loading = false;
          this.success = false;
          this.message = 'Failed to retrieve setup intent details.';
        },
      });
  }

  saveTransactionAndUpdateCookie(
    transactionBody: any,
    isSuccess: boolean
  ): void {
    console.log('Body to be saved in DB:', JSON.stringify(transactionBody));
    console.log('perennialStripeUserDetails',this.perennialStripeUserDetails);
    if (
      this.perennialStripeUserDetails.user_id != undefined ||
      this.perennialStripeUserDetails.user_id != null
    ) {
      this.apiservice
        .getHttpDataPost(
          'cart_management/perennial-mandalism-transaction',
          transactionBody
        )
        .subscribe({
          next: (response) => {
            console.log(
              'Response from cart_management/perennial-mandalism-transaction:',
              response
            );
            if (response.status === 'success') {
              if (isSuccess) {
                console.log('Transaction saved successfully. Updating cookie.');
                let oldcookie = this.cookieService.get('login_user_details')
                  ? JSON.parse(this.cookieService.get('login_user_details'))
                  : null;

                if (!oldcookie) {
                  console.warn(
                    "Old cookie 'login_user_details' not found. Cannot update subscription status in cookie."
                  );
                  return;
                }

                const currentDate = new Date();
                const futureDate = new Date(currentDate);
                futureDate.setDate(currentDate.getDate() + 30);
                futureDate.setHours(23, 59, 59, 999);
                const futureTimestamp = futureDate.getTime();

                let newcookie = {
                  ...oldcookie,
                  userinfo: {
                    ...oldcookie.userinfo,
                    perennial_subscription_status: true,
                    perennial_mandalism_status: 'subscription running',
                    perennial_subscription_id:
                      this.perennialStripeUserDetails.subscription_id,
                    perennial_current_period_end: futureTimestamp,
                  },
                };

                console.log('New cookie to be set:', newcookie);
                this.cookieService.set(
                  'login_user_details',
                  JSON.stringify(newcookie),
                  { path: '/' }
                );
                console.log('Cookie updated.');
              }
            } else {
              console.error(
                'Failed to save transaction to DB. API response status:',
                response.status
              );
            }
          },
          error: (err) => {
            console.error(
              'Error calling cart_management/perennial-mandalism-transaction API:',
              err
            );
          },
        });
    } else {
      console.warn(
        'User ID missing in perennialStripeUserDetails. Skipping DB transaction save.'
      );
    }
  }

  gotToDashBoard(path: any) {
    this.cookieService.delete('perennialStripeUserDetails', '/');
    this.router.navigateByUrl(`${path}`);
  }
}
